/**
 * Canonical URLs for the IPL Fantasy season-recap media (hosted on Vercel
 * Blob). Imported by the fantasy page, its metadata/layout, the home-page tile,
 * and the JSON-LD VideoObject so the blob paths live in exactly one place.
 *
 * - `og`: H.264 baseline encode sized for social/OG video unfurls.
 * - `web`: the full-quality encode played and downloaded on the page.
 * - `poster`: still frame used as the video poster and OG image.
 */
export const FANTASY_RECAP = {
  og: 'https://mp6zm9vudil8sqsf.public.blob.vercel-storage.com/fantasy/recap-og.mp4',
  web: 'https://mp6zm9vudil8sqsf.public.blob.vercel-storage.com/fantasy/recap-web.mp4',
  poster:
    'https://mp6zm9vudil8sqsf.public.blob.vercel-storage.com/fantasy/recap-poster.jpg',
} as const

/** Download filename for the recap video. */
export const FANTASY_RECAP_FILENAME = 'ipl-fantasy-2526-recap.mp4'
